import React from 'react';
import {connect} from 'react-redux';
import accountManagement from '../../../../apis/accountManagement';
import KelasSearch from '../../../../entity/KelasSearch';
import KelasParalelSearch from '../../../../entity/KelasParalelSearch';
import SiswaKelasParalel from '../../../../entity/SiswaKelasParalel';
import {cekCookies} from '../../../../actions';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { CONFIG } from '../../../../config';
import LoaderModal from '../../../modal/LoaderModal';
import Loader from '../../../Loader';
import __ from 'lodash';
import ListTableSiswa from './ListTabelSiswa';
import { Alert, Form } from 'react-bootstrap';


import DropdownKelas from '../masterDropDown/DropdownKelas';
import DropdownKelasParalel from '../masterDropDown/DropdownKelasParalel';
import DropdownTahunAjaran from '../masterDropDown/DropdownTahunAjaran';
import ReactExport from "react-data-export";
import { Link } from '@material-ui/core';

class Siswa extends React.Component{
    constructor(props){
        super(props);
        this.state = {            
            kelas:[], 
            idKp:null,
            ta:[],
            kodeTa: null,
            isCetakVoucher : false,
            showModalCetakVoucher : false,
            isDownload : false,
            listPaketProgram : [],
            listVoucher : [],
            idPaketProgram : null,
            KelasParalelSearch :[],
            SiswaKelasParalel :[],
            username:null,
            sekolah:{}, 
            selectedKelas: null, 
            profilCbt: [], 
            loadCbt: false, 
            namaProfilFilter: null, 
            page: 0, 
            size: 5,
            endPage: false,
            totalData: 0,
            isFetching: false,
            isSearchUsername : false,
            searchSiswa: null,
            namaKelasParalel: null,
            alertShow: false,
            alertMessage: ''
        }
    }


    async componentDidMount(){
        document.title = "All Siswa"
        this.setState({isFetching: true});
        await this.props.cekCookies();
        this.setState({isFetching: false});
        if(!__.isEmpty(this.props.account)){
            this.fetchKelas();
            this.fetchTa();
        }  
    }

    fetchTa = async () =>{
        //fetch tahun ajaran dulu
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN).catch(function(error){
        })
        if(resTa){
            if(resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    ta: resTa.data.data
                })
            }
        }
        console.log(resTa)

        resTa.data.data.map((val) =>{
            if(val.status == "1"){
                this.setState({kodeTa:val.kodeTahunAjaran})
            }
        })
    }

    fetchKelas = async () =>{
        this.setState({isFetching: true});

        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function(error){
        })
        if(resSekolah){
            if(resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    sekolah: resSekolah.data.data
                })
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {KelasSearch, ["kodeJenjangSekolah"]: this.state.sekolah.kodeJenjangSekolah}).catch(function(error){
        });

        // masukan data kelas ke dropdown
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: response.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }

    handleOnChangeKelasParalel = async (kode) =>{
        this.setState({
            isCetakVoucher : false,
            kodeTa: kode.target.value
        })
    }

    handleOnChangeKelas = async (idKelas) => {
        this.setState({     
            isCetakVoucher : false,       
            selectedKelas: idKelas.target.value
        })
        
        this.setState({isFetching: true});
        this.state.KelasParalelSearch=[];
        this.state.SiswaKelasParalel=[];
        this.setState({idKp : ''})
        //fetch kelas pararelnya dulu
        const resKelasParalel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, {KelasParalelSearch,['idKelas']: idKelas.target.value, ['idSekolah']: this.props.account.idSekolah}).catch (function(error){
        })  

        // masukan kelas paralel ke  dropdown
        if(resKelasParalel){
            if(resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    KelasParalelSearch: resKelasParalel.data.data
                })
            }
        }
        // this.showSiswaSearch();

        this.setState({isFetching: false});
    }

    handleOnChangeKelasParalel = async (idKelasParalel) => {
        if(!__.isEmpty(idKelasParalel.target.value)){
            this.state.KelasParalelSearch.map((map, i)=>
                {map.idKelasParalel == idKelasParalel.target.value &&
                    this.setState({    
                        SiswaKelasParalel : [],      
                        isDownload : false,
                        isCetakVoucher : false,  
                        idKp: idKelasParalel.target.value,
                        namaKelasParalel: map.namaKelasParalel
                    }) 
                }
                
            )  
        }  
        // this.showSiswaSearch();

    }

    hanldeOnChangeTa = async (e)=>{
        this.setState({
            isCetakVoucher : false,
            kodeTa:e.target.value
        })
    }

    showSiswaSearch = async ()=>{
        this.setState({isFetching: true, alertShow: false});
        this.state.SiswaKelasParalel=null
        
        if(this.state.idKp === null) {
            this.setState({
                alertShow: true,
                isFetching: false,
                alertMessage: 'Pilih Kelas Paralel... !!'
            });
            return false;
        }
        // cari siswa di kelas tersebut
        const resSiswaKelasParelel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_SISWA_BY_KELAS_PARALEL,{...SiswaKelasParalel,
            ['idKelas']: this.state.selectedKelas,
            ['idKelasParalel']: this.state.idKp,
            ['idSekolah']: this.props.account.idSekolah,
            ['kodeTahunAjaran']: this.state.kodeTa
        }).catch (function(error){
        })

        // masukan siswa ke array
        if(resSiswaKelasParelel){
            if(resSiswaKelasParelel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    isCetakVoucher : true,
                    SiswaKelasParalel: resSiswaKelasParelel.data.data
                });
                this.fetchPP();
            }
        }else{
            this.setState({
                isCetakVoucher : false
            })
        }
        this.setState({isFetching: false});
    }

    componentDidUpdate = async () =>{
        console.clear();
        console.log(this.state);
        /* if(this.state.isSearchUsername){
            if(this.state.searchSiswa!=null || this.state.selectedKelas!=null || this.state.idKp!=null){
                const resUsername = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_SISWA_BY_USERNAME+
                    this.state.searchSiswa+"-"+
                    this.state.kodeTa+"-"+
                    this.state.selectedKelas+"-"+
                    this.state.idKp+"-"+
                    this.props.account.idSekolah).catch (function(error){})
                this.setState({SiswaKelasParalel:resUsername.data.data, isSearchUsername: false})
            }
        } */
    }

    usernameOnchange = async (e) =>{
        this.setState({searchSiswa:e.target.value})
        this.setState({isSearchUsername:true, alertShow: false});
        if(this.state.searchSiswa!=null || this.state.selectedKelas!=null || this.state.idKp!=null){
            const resUsername = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_SISWA_BY_USERNAME+
                e.target.value+"-"+
                this.state.kodeTa+"-"+
                this.state.selectedKelas+"-"+
                this.state.idKp+"-"+
                this.props.account.idSekolah).catch (function(error){})
            this.setState({SiswaKelasParalel:resUsername.data.data, isSearchUsername: false})
        }
    }

    loading = () =>{
        if(this.state.isSearchUsername){
            return(
                <Loader />
            )
        }
    }

    loadAlert = () => {
        const {alertShow, alertMessage } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{alertMessage}</strong>
            </Alert>
          );
        } 
    }

    resetPassword = async(id) => {
        this.setState({isFetching: true});
        const resResPasss = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_RESET_PW_SISWA, {SiswaKelasParalel,['idSiswa']: id})
        .catch (function(error){ })
        if(resResPasss){
            this.setState({
                alertShow: true,
                alertMessage: resResPasss.data.errorSchema.errorMessage
            });
        }
        this.setState({isFetching: false});
    } 

    render(){
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />  
                    <h4>Management Siswa</h4>
                    <div className="row">
                        <div className="col-md-2">
                            <select className="form-control" value={this.state.kodeTa} onChange={this.hanldeOnChangeTa} required>
                                <option value="" selected disabled>~~ Pilih Tahun Ajaran ~~</option>
                                <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                            </select>
                        </div>
                        <div className="col-md-3">                            
                            <select className="form-control" value={this.state.selectedKelas} onChange={this.handleOnChangeKelas} required>
                                <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                <DropdownKelas kelas={this.state.kelas} />
                            </select>
                        </div>
                        <div className="col-md-3">                           
                            <select className="form-control" value={this.state.idKp} onChange={this.handleOnChangeKelasParalel} required>
                                <option value="" selected disabled>~~ Pilih Kelas Paralel ~~</option>
                                <DropdownKelasParalel kelasParalel={this.state.KelasParalelSearch} />
                            </select>
                        </div>
                        <div className="col-md-3">
                            <button className="btn btn-primary" onClick={this.showSiswaSearch}><i className="fa fa-search"> Cari</i></button>                            
                            {/* {this.state.isCetakVoucher &&
                                <button className="btn btn-warning pull-right" onClick={() => this.setState({ showModalCetakVoucher : true })}><i className="fa fa-print"> Cetak Akun</i></button>
                            }                         */}
                            {
                                !__.isEmpty(this.state.SiswaKelasParalel) &&
                                    <ExcelFile element={<button className="btn btn-outline-danger pull-right" ><i className="fa fa-print"> Download</i></button>} filename={this.props.account.namaUser+" - "+this.state.namaKelasParalel}>
                                        <ExcelSheet data={this.state.SiswaKelasParalel} name={"Username Kelas "+this.state.namaKelasParalel}>
                                            <ExcelColumn label="Nama Siswa" value="namaSiswa"/>
                                            <ExcelColumn label="Username" value="username"/>
                                            <ExcelColumn label="Kelas" value={() => this.state.namaKelasParalel}/>
                                            <ExcelColumn label="Password" value="passwordSiswa"/>
                                        </ExcelSheet>

                                    </ExcelFile>

                                // <button className="btn btn-outline-danger pull-right" ><i className="fa fa-print"> Download</i></button>
                            }

                        </div>
                    </div> 
                    <small className="pull-left" style={{marginTop: '10px'}}><i><span className="text-danger">*</span>Silahkan cari siswa berdasarkan filter yang tersedia</i></small>
                    <br/><br/>
                    <div className="row">
                        <div className="col-md-8">
                            
                        </div>
                        <div className="col-md-4">                            
                            <div className="col-md-12">
                                <input className="form-control" value={this.state.searchSiswa} onChange={this.usernameOnchange} placeholder="Search Siswa"/>
                            </div>                            
                        </div>
                    </div> 
                    {this.loadAlert()}  
                    {this.modalPilihPP()}
                        <br></br>
                        {this.loading()}
                            <ListTableSiswa listSiswa={this.state.SiswaKelasParalel} resetPassword={this.resetPassword}/>
                        {this.loading()}
                </div>
            </div>
        )
    }

    modalPilihPP() {
        // if(false) {
            if(this.state.showModalCetakVoucher) {
            return(
                <div className="modal fade show" id="modalLoader" style={{ display: 'block', backgroundColor: 'rgba(91, 140, 184, 0.24)', overflow: 'auto' }} tabIndex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog modal-md" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">{this.state.titleModal}</h5>
                                <span aria-hidden="true"></span>
                            </div>

                            <Form onSubmit={this.handleSubmit}>
                                <div class="modal-body">

                                    <div className="form-group">
                                        <label>Pilih siswa berdasarkan Aktivasi Paket Program</label>
                                        <select className="form-control" value={this.state.idPaketProgram} onChange={this.handleOnChangePaketProgram} required>
                                            <option value="" selected disabled>~~ Pilih Paket Program ~~</option>
                                            {this.renderDropdown()}
                                        </select>
                                    </div>
                            
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger pull-left" onClick={() => this.setState({showModalCetakVoucher : false})}>Cancel</button>
                                    <button type="submit" class="btn btn-primary pull-right">Cetak</button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            );
        }
    }



    fetchPP = async ()=>{
        const restPP = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_PAKET_PROGRAM_BY_KELAS_PARALEL,{...SiswaKelasParalel,
            ['idKelas']: this.state.selectedKelas,
            ['idKelasParalel']: this.state.idKp,
            ['idSekolah']: this.props.account.idSekolah,
            ['kodeTahunAjaran']: this.state.kodeTa
        }).catch (function(error){
        })

        if(restPP){
            if(restPP.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    listPaketProgram: restPP.data.data.listPaketProgram
                });
            }
        }
    }

    renderDropdown(){
        if(!__.isEmpty(this.state.listPaketProgram)){
            return this.state.listPaketProgram.map((val) => {
                return (<option value={val.ID_PAKET_PROGRAM}>{val.NAMA_PROGRAM}</option>)               
            })
        }
    }

    handleOnChangePaketProgram= async(e)=>{this.setState({idPaketProgram:e.target.value})}

    handleSubmit= async (e) => {
        console.clear();
        e.preventDefault();
        const restVoucher = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_VOUCHER_BY_KELAS_PARALEL_PAKET_PROGRAM,{
            ['idKelas']: this.state.selectedKelas,
            ['idKelasParalel']: this.state.idKp,
            ['idSekolah']: this.props.account.idSekolah,
            ['kodeTahunAjaran']: this.state.kodeTa,
            ['idPaketProgram']: this.state.idPaketProgram
        }).catch (function(error){
        })

        if(restVoucher){
            if(restVoucher.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    listVoucher: restVoucher.data.data.listVoucher
                });
            }
        }
        restVoucher.data.data.listVoucher.map((val, i) =>{
            
            // <Link to={'/cetakuser/839446'} className="btn btn-primary">Detail</Link>
            // window.open('http://localhost:5000/cetakuser/839446' , '_blank');
            console.log(val.NAMA_SISWA);
        })
    }
}
const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(Siswa);